import { firebase } from '@/firebase/firebase'
import modelAccount from "@/models/Account"

const Moment = require("moment")

const state = {
  account:{},
  investments:[],
  transactions:[]
}
const getters = {
    account: state =>{
      return state.account
    },
    transactions: state=>{
      return state.transactions.slice(0,20)
    }
}
const mutations = {
  setAccount (state, value) {
    //console.log('mutation set events '+value);
    state.account = value;
  },
  setTransactions (state, value) {
    state.transactions = value;
  }
}
const actions = {
  async fetchAccount ({state,commit,rootState,rootGetters}) {
    //console.log('store.account.fetchAccount:',rootState.auth.uid);
    await firebase.firestore().collection("Account").doc(rootState.auth.uid).onSnapshot(docdata => {
      if (docdata.exists) {
        var fbdata = new modelAccount(docdata.data())
      }
      else {
        var fbdata = new modelAccount({})
      }
      fbdata.id = rootState.auth.uid
      commit("setAccount", fbdata)
    })

    await firebase.firestore().collection("Transactions").where("userID","==",rootState.auth.uid).orderBy("date","desc").onSnapshot(docdata => {
      let arr = []
      docdata.forEach((doc) => {
        let elem = doc.data()
        let d = new Moment(elem.date.toDate()||'')
        elem.date = d.format('DD.MM.YY hh:mm') || ''
        elem.id = doc.id
        arr.push(elem)
      })
      //console.log('loaded transactions',arr);

      commit("setTransactions", arr)
    })
  },
  async addBalance ({state,rootState},sum) {
    console.log('store.account.addBalance:',rootState.auth.uid, sum)
    var fnc = firebase.functions().httpsCallable('addBalance');
    return fnc({sum: Number(sum),userID:rootState.auth.uid,type:'Пополнение счета'}).then((result)=>{
        console.log('transaction result',result.data);
      })
  }

}
const storeConf = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
export default storeConf



// WEBPACK FOOTER //
// ./storage/modules/accountstore.js